<template>
  <div
      class="font-light text-base"
      :style="helpTextColor"
  >
    <slot></slot>
  </div>
</template>

<script>
import themeMixin from "../mixins/theme.mixin";

export default {
  name: "TextHelp",
  mixins: [themeMixin],
}
</script>

<style scoped>

</style>
